import { UserProfileDetailsInfos } from '../userProfileDetails';
import ProfilePictureItemGrid from '../ProfilePictureItemGrid';
import { useDocumentTitle } from './hooks';
import { Separator } from '../../ui';
import { useProfileUserStore } from './store/profileUserStore';

const ProfileDetailUserDataPhotos = () => {
	const { userData } = useProfileUserStore();

	useDocumentTitle({ userData: userData! });

	if (!userData) {
		// Basic loading state or null while fetching
		return <div className="animate-pulse h-64 bg-muted/20 rounded-md" />;
	}

	return (
		<div className="flex flex-col gap-5 animate-in fade-in slide-in-from-bottom-2 duration-500">
			{/* pictures */}
			<ProfilePictureItemGrid
				userId={userData._id}
				showUnverifiedPictures
				pictures={userData.pictures}
				className={'px-0 gap-5'}
				imageContainerClassName={'w-36 self-end'}
				certifPhoto={userData.verifications?.id?.photo}
				certifPhotoStatus={userData?.verifications?.id?.status} />
			<Separator className='bg-muted' />
			{/* Others stats */}
			<span className={'text-center font-semibold text-sm'}>
				Plus d'infos
			</span>
			<UserProfileDetailsInfos
				hideCountry
				hideCoins
				hideEmail
				hideAge
				align='center'
				userData={userData}
				className='justify-center mx-auto' />
		</div>
	);
};

export default ProfileDetailUserDataPhotos;
